import { render, staticRenderFns } from "./projectCourseList.vue?vue&type=template&id=0e8f7bb0&scoped=true&"
import script from "./projectCourseList.vue?vue&type=script&lang=js&"
export * from "./projectCourseList.vue?vue&type=script&lang=js&"
import style0 from "./projectCourseList.vue?vue&type=style&index=0&id=0e8f7bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f7bb0",
  null
  
)

export default component.exports